import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { IEvent } from "../interfaces/ievent";
import { EventService } from "../services/event.service";
import { Observable } from "rxjs";

@Injectable()
export class EventResolver implements Resolve<IEvent> {

    constructor(private eventService: EventService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IEvent> {
        return this.eventService.getEvent(route.params["id"]);
    }
}
